import { render } from "./Merchant.vue?vue&type=template&id=54b44cbd&scoped=true"
import script from "./Merchant.vue?vue&type=script&lang=js"
export * from "./Merchant.vue?vue&type=script&lang=js"

import "./Merchant.vue?vue&type=style&index=0&id=54b44cbd&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b44cbd"]])

export default __exports__